import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RadioButton } from '../../../common/RadioButton';
import { REIMBURSEMENT_METHODS } from '../../../../constants';
import styles from '../css/SecondaryReimbursementMethodList.module.css';
import { changeReimbursementSecondaryMethodType } from '../../../../actions';
import { EditReimbursementModalButtons } from './EditReimbursementModalButtons';

const SecondaryReimbursementMethodList = ({
  goNext = () => { },
  goBack = () => { },
}) => {
  const { t } = useTranslation('myAccount');
  const secondaryMethod =
    useSelector(({ billingPayments }) => (
      billingPayments.reimbursementData.secondaryMethod), shallowEqual);
  const { secondaryReimbursementMethod } = secondaryMethod;
  const dispatch = useDispatch();

  const isBankAccountActive = secondaryReimbursementMethod
    === REIMBURSEMENT_METHODS.deposit;

  const isCheckActive = secondaryReimbursementMethod
    === REIMBURSEMENT_METHODS.check;

  const getClassName = useCallback((isActive) => `${styles.radioButton} `
    + `${isActive ? styles.radioButtonSelected : ''}`, []);

  const onRadioButtonChange = useCallback((event) => {
    const { value } = event.target;
    dispatch(changeReimbursementSecondaryMethodType(Number(value)));
  }, [dispatch]);

  const handleBack = useCallback(() => {
    dispatch(changeReimbursementSecondaryMethodType());
    goBack();
  }, [dispatch]);

  return (
    <div className={styles.reimbursementMethodContainer}>
      <h4 className={styles.contentTitle}>
        {t('reimbursementSection.editModal.careCredit')}
      </h4>

      <fieldset>
        <legend className={styles.legend}>
          {t('reimbursementSection.secondaryMethod.legend')}
        </legend>

        <RadioButton
          blue
          checked={isCheckActive}
          className={getClassName(isCheckActive)}
          id="reimbursement-check"
          name="reimbursementMethod"
          onChange={onRadioButtonChange}
          value={REIMBURSEMENT_METHODS.check}
        >
          {t('reimbursementSection.editModal.check')}
        </RadioButton>

        <RadioButton
          blue
          checked={isBankAccountActive}
          className={getClassName(isBankAccountActive)}
          id="reimbursement-bank-account"
          name="reimbursementMethod"
          onChange={onRadioButtonChange}
          value={REIMBURSEMENT_METHODS.deposit}
        >
          {t('reimbursementSection.editModal.directDeposit')}
        </RadioButton>
      </fieldset>

      <EditReimbursementModalButtons
        handleEditReimbursementAccept={goNext}
        handleEditReimbursementCancel={handleBack}
        isFormInvalid={!secondaryReimbursementMethod}
      />
    </div>
  );
};

export { SecondaryReimbursementMethodList };
